module.exports = __webpack_public_path__ + "img/transfer_transactions_active.69c5f624.svg";